import Coms from '@/communications'
import bus from '@/plugins/bus'
import axios from '@/plugins/axios.js' 
import isEmpty from 'lodash/isEmpty'
import delay from 'lodash/delay'
import isNil from 'lodash/isNil'

export default {
  async uploadPreviewImage (_, { id, file, notify }) {
    const willNotify = isNil(notify) ? true : notify

    try {
      // Get upload token
      const token = await Coms.view.getViewPreviewUploadToken(id)

      // Prepare upload
      const formData = new FormData()
      formData.append('image', file)

      // Send file to API
      const response = await axios.post('api/v1/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Token': token,
          'Socket-Id': Coms.util.getSocketId()
        }
      })

      if (isEmpty(response.data.photo)) {
        const error = 'No image path was returned from the server.'
        console.error(error)
        if (willNotify) {
          bus.emit('notification', error, { color: 'error', dark: true })
        }
        throw new Error(error)
      }

      // Check if uploaded asset is available
      let tries = 0
      const checkForAsset = async () => {
        try {
          await axios.head(response.data.photo)
          if (willNotify) {
            bus.emit('notification', 'The preview image was updated successfully.', {
              color: 'success',
              dark: true
            })
          }
          return response.data.photo
        } catch (err) {
          if (tries < 10) {
            tries++
            await new Promise(res => delay(res, 1000))
            return checkForAsset()
          } else {
            const error = 'The image was uploaded, but the path obtained seems to be invalid.'
            console.error(err, error)
            if (willNotify) {
              bus.emit('notification', error, { color: 'error', dark: true })
            }
            throw new Error(error)
          }
        }
      }

      return await checkForAsset()

    } catch (error) {
      console.error(error.response || error.request || error.message || error)
      if (willNotify) {
        let message
        if (error.response) {
          message = error.response.data
        } else if (error.request) {
          message = 'Upload Failed. The server did not respond.'
        } else {
          message = error.message || 'An unknown error occurred.'
        }
        bus.emit('notification', message, { color: 'error', dark: true })
      }
      throw error
    }
  }
}
